import React from 'react';
import DocumentTitle from 'react-document-title';
import COLORS from '../../constants/colors';
import ProductTitle from '../../components/ProductTitle';
import ProductLineup from '../../components/ProductLineup';
import ProductVariant from '../../components/ProductVariant';
import ProductCustom from '../../components/ProductCustom';
import ProductFAQ from '../../components/ProductFAQ';
import ProductExamples from '../../components/ProductExamples';
import ProductDetails from '../../components/ProductDetails';
import ProductStyleElements from '../../components/ProductStyleElements';
import ProductImagery from '../../components/ProductImagery';
import ProductPlanningTesting from '../../components/ProductPlanningTesting';
import ProductEcommerce from '../../components/ProductEcommerce';
import ProductFooter from '../../components/ProductFooter';
import SectionTitle from '../../components/SectionTitle';
import uiGuideImage from './assets/ui_guide_image.png';
import uiGuideDetailImage from './assets/ui_detail.png';
import mvpImage from './assets/mvp_image.png';
import mvpDetailImage from './assets/mvp_detail.png';
import advancedImage from './assets/advanced_image.png';
import advancedDetailImage from './assets/advanced_detail.png';
import footerBackground from './assets/footer.png';

const uiGuideVariant = (
  <section>
    <div>
      <p>Button Styles, Animations</p>
      <p>Fonts & Type guide</p>
      <p>Color Palette</p>
    </div>
    <div>
      <p>
        Great for business or development teams that need styles created but
        don't need a complete redesign.
      </p>
    </div>
    <div>
      <p>Managed by DesignCue</p>
      <p>Design Only. No Code.</p>
    </div>
  </section>
);

const mvpVariant = (
  <section>
    <div>
      <p>Wireframing</p>
      <p>Desktop and Mobile Views</p>
      <p>3-5 Screen Designs</p>
    </div>
    <div>
      <p>Button Styles, Animations</p>
      <p>Fonts & Type guide</p>
      <p>Color Palette</p>
    </div>
    <div>
      <p>
        A Minimum Viable Product is a great way to launch your new business
        or refresh your existing web app.
      </p>
    </div>
    <div>
      <p>Managed by DesignCue</p>
      <p>Design Only. No Code.</p>
    </div>
  </section>
);

const advancedVariant = (
  <section>
    <div>
      <p>Wireframing</p>
      <p>Prototyping</p>
      <p>Screen Animations</p>
    </div>
    <div>
      <p>Desktop and Mobile Views</p>
      <p>5-10 Screen Designs</p>
    </div>
    <div>
      <p>Button Styles, Animations</p>
      <p>Fonts & Type guide</p>
      <p>Color Palette</p>
    </div>
    <div>
      <p>
        Great for startups looking for a more polished product including
        animations and ecommerce integration.
      </p>
    </div>
    <div>
      <p>Managed by DesignCue</p>
      <p>Design Only. No Code.</p>
    </div>
  </section>
);

const uiGuideDescription = (
  <section>
    <div>
      <p>
        UI guides are great for business or development teams that need styles
        created but don't need a complete redesign.
      </p>
    </div>
    <div>
      <p>
        Easily implement our color choices, button styles, and fonts and
        bootstrap the rest.
      </p>
    </div>
  </section>
);

const uiGuideIncludes = [
  "button styles",
  "button animations",
  "fonts",
  "type guide",
  "color palette"
];

const mvpDescription = (
  <section>
    <div>
      <p>
        A Minimum Viable Product is the best way to launch your new business or
        revive your existing web app. Users appreciate clean interfaces and
        straight-forward functionality.
      </p>
    </div>
    <div>
      <p>
        We'll determine the essentials for getting your app off the ground and
        design features to support it.
      </p>
    </div>
  </section>
);

const mvpIncludes = [
  "wireframe of core functionality",
  "3-5 screen designs",
  "desktop and mobile views",
  "button styles, animations",
  "color palette"
];

const advancedDescription = (
  <section>
    <div>
      <p>
        Advanced app designs are best for startups looking for a more polished
        product. Along with all the great functionality of an MVP, you'll get an
        e-commerce page for online selling and page animations throughout.
      </p>
    </div>
    <div>
      <p>
        The best apps are designed with "human-like" functionality that allows
        users to use it like an extension of themselves. You'll get full screen
        designs along with wireframing and prototyping for testing.
      </p>
    </div>
  </section>
);

const advancedIncludes = [
  "5-10 page designs",
  "wireframing",
  "prototyping",
  "ecommerce design",
  "screen animations",
  "desktop and mobile views",
  "interactive animations",
  "button styles, animations",
  "fonts and type guide",
  "color palette"
];



const color = COLORS.PURPLE;

function WebApp() {
  return (
    <DocumentTitle title='DesignCue - Web App Design'>
      <div>
        <ProductTitle>Web App Design</ProductTitle>
        <ProductLineup>
          <ProductVariant
            image={uiGuideImage}
            title="UI Guide"
            details={uiGuideVariant}
            cost="$850 - 7 days"
            query={{ product: 'UI Guide' }}
            color={color}
          />
          <ProductVariant
            image={mvpImage}
            title="MVP"
            details={mvpVariant}
            cost="$10,000 - 10 days"
            query={{ product: 'MVP' }}
            color={color}
          />
          <ProductVariant
            image={advancedImage}
            title="Advanced App"
            details={advancedVariant}
            cost="$22,500 - 3 weeks"
            query={{ product: 'Advanced App' }}
            color={color}
          />
        </ProductLineup>
        <ProductCustom />
        <ProductFAQ />
        <ProductExamples
          type="WEB APP"
          examples="SoundCloud, Slack & DoorDash"
        />
        <div className="mt100" />
        <SectionTitle color={color}>
          WHAT'S INCLUDED
        </SectionTitle>
        <hr className="mt20"/>
        <ProductDetails
          title="UI Guide"
          color={COLORS.GREEN}
          includes={uiGuideIncludes}
          description={uiGuideDescription}
          image={uiGuideDetailImage}
        />
        <hr />
        <ProductDetails
          title="MVP"
          color={COLORS.BLUE}
          includes={mvpIncludes}
          description={mvpDescription}
          image={mvpDetailImage}
        />
        <hr />
        <ProductDetails
          title="Advanced App"
          color={COLORS.PURPLE}
          includes={advancedIncludes}
          description={advancedDescription}
          image={advancedDetailImage}
        />
        <hr />
        <ProductStyleElements color={color} />
        <hr />
        <ProductImagery color={color} />
        <hr />
        <ProductPlanningTesting color={color} />
        <hr />
        <ProductEcommerce color={color} />
        <hr className="bg-below" />
        <ProductFooter background={footerBackground} />
      </div>
    </DocumentTitle>
  );
}

export default WebApp;



// WEBPACK FOOTER //
// ./src/pages/WebApp/index.js